import { render } from '@wordpress/element';
import App from './components/App';

document.addEventListener('DOMContentLoaded', () => {
    const root = document.getElementById('pbfw_admin_app');
    if (root) render(<App />, root);
});
